<template>
  <section class="timers">
    <div class="timer-group">
      <Timer title="Days" :value="days" />
      <Timer title="Hours" :value="hours" />
      <Timer title="Mins" :value="minutes" />
      <Timer title="Secs" :value="seconds" />
    </div>
  </section>
</template>

<script>
import Timer from "@/components/shared/TimerV2";

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export default {
  components: { Timer },
  props: ["expiresOn"],
  data: () => ({
    date: "",
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    intervalId: null
  }),
  async mounted() {
    this.countDown();
    this.intervalId = setInterval(this.countDown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    countDown() {
      const diff = this.expiresOn - new Date();
      if (diff < 0) return;
      this.days = Math.floor(diff / DAY);
      this.hours = Math.floor((diff % DAY) / HOUR);
      this.minutes = Math.floor((diff % HOUR) / MINUTE);
      this.seconds = Math.floor((diff % MINUTE) / SECOND);
      if (
        this.days === 0 &&
        this.hours === 0 &&
        this.minutes === 0 &&
        this.seconds === 0
      )
        location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  text-transform: uppercase;
}

.timer-group {
  display: flex;
  justify-content: center;
}
</style>